import React from 'react'
import { Link, useLocation } from 'react-router-dom'

const NavBtnPC = ({ title, locations }) => {

  const location = useLocation();

  return (
    <Link className={`h-16 flex flex-col justify-center ease-in-out items-center w-full rounded-t-md px-3 transition duration-100 tracking-wide border-yellow-500
    ${locations.split('/')[1] === location.pathname.split('/')[1] 
    ? 'bg-[#2E2E2E]/80 border-b-4 opacity-90'
    : 'hover:-translate-y-[3px] ease-in-out duration-100 hover:bg-[#4E4E4E]/50 active:bg-transparent active:opacity-50 active:translate-y-0'
    }`} 
      to={locations}
    >
      {title}
    </Link>
  )
}

export default NavBtnPC